export default __webpack_public_path__ + "static/media/back-big.bb647f45.svg";